import { FormattedMessage } from 'react-intl';
import styles from './styles.module.scss';

export const Licence = () => (
  <div className={styles.license}>
    <FormattedMessage defaultMessage="Номер лицензии ТОО “Legal Money” 05.22.0002.М. от 15.11.2022 года" />
  </div>
);
